export const getInvoices = () => `invoices/invoices/`;

export const getPromotionalCodes = () =>`invoices/promo-codes/`;
   
   